import { createApp } from 'vue';
import SevenZipToTarConverter from '@/Components/SevenZipToTarConverter.vue';
import '@styles/app.css';

createApp(SevenZipToTarConverter).mount('#sevenzip-to-tar-converter');
